import React from 'react';
import { motion } from 'framer-motion';
import ScrollStack from './ScrollStack';
import ScrollFloat from './ScrollFloat';
import './Skills.css';

const Skills = () => {
  const skillCards = [
    {
      icon: '☁️',
      title: 'Cloud Platforms',
      description: 'Running production workloads across AWS and Azure',
      tags: ['AWS', 'Azure', 'EC2', 'Lambda', 'S3', 'IAM', 'CloudWatch']
    },
    {
      icon: '⚙️',
      title: 'DevOps & Automation',
      description: 'Infrastructure as code, containers, and delivery pipelines',
      tags: ['Kubernetes', 'CI/CD', 'GitHub Actions', 'Docker', 'Terraform', 'Linux', 'NGINX']
    },
    {
      icon: '🔒',
      title: 'Security & Reliability',
      description: 'Least-privilege access, hardening, and recovery planning',
      tags: ['Access Control', 'Zero Trust', 'SSL/TLS', 'Patching', 'Compliance', 'DR Planning']
    },
    {
      icon: '💻',
      title: 'Engineering & Tooling',
      description: 'Languages and tools I build and troubleshoot with',
      tags: ['Go', 'Bash', 'Git', 'Linux', 'Elasticsearch', 'Power BI']
    }
  ];

  const cards = skillCards.map((skill, index) => (
    <div key={index} className="skill-card-stack">
      <div className="skill-icon-large">{skill.icon}</div>
      <h3>{skill.title}</h3>
      <p className="skill-description">{skill.description}</p>
      <div className="skill-tags">
        {skill.tags.map((tag, i) => (
          <span key={i} className="skill-tag">{tag}</span>
        ))}
      </div>
    </div>
  ));

  return (
    <section id="skills" className="section snap-section skills-section">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: false, amount: 0.3 }}
        >
          <h2 className="section-title">
            <ScrollFloat>Skills & Technologies</ScrollFloat>
          </h2>
          <p className="section-subtitle">The stack I work in day to day</p>
        </motion.div>
        
        <ScrollStack cards={cards} />
      </div>
    </section>
  );
};

export default Skills;
